import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: "",
  email: "",
  newUser: false,
  isEmailVerified: false,
  profileImage: "",
  walletAddress: "",
  signMessageData: "",
  signSignatureData:"",
  walletBalance: 0,
  isConnectingModal:false,
  isVerifyEmailModal:false,
  isSignMessageModal:false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUser: (state, action) => {
      const { user, email, profileImage, walletAddress , isEmailVerified} = action.payload;
      state.user = user !== undefined ? user : state.user;
      state.email = email !== undefined ? email : state.email;
      state.isEmailVerified = isEmailVerified !== undefined ? isEmailVerified : state.isEmailVerified;
      state.profileImage =
        profileImage !== undefined ? profileImage : state.profileImage;
      state.walletAddress =
        walletAddress !== undefined ? walletAddress : state.walletAddress;
    },
    setUserEmail: (state, action) => {
      state.email = action.payload;
    },
    setSignMessageData: (state, action) => {
     state.signMessageData = action.payload
    },
    setSignSignatureDate: (state, action) => {
      state.signSignatureData = action.payload;
    },
    clearUserData: (state) => {
      return {
        ...initialState,
        signMessageData: state.signMessageData,
        signSignatureData: state.signSignatureData,
        isSignMessageModal: state.isSignMessageModal
      };
    
    },
    updateNewUser: (state, action) => {
      state.newUser = action.payload;
    },
    setUserBalance: (state, action) => {  
      state.walletBalance = action.payload;
    },
    setConnectingModal:(state,action) =>{
      state.isConnectingModal =action.payload
    },
    setVerifyEmailModal:(state,action) =>{
      state.isVerifyEmailModal =action.payload
    },
    setSignMessageModal:(state,action) =>{
      state.isSignMessageModal =action.payload
    }
  },
});

export const { updateUser, clearUserData, setUserEmail, updateNewUser ,setUserBalance,setConnectingModal,setVerifyEmailModal,setSignMessageModal,setSignMessageData,setSignSignatureDate} =
  userSlice.actions;
export default userSlice.reducer;
